module.exports = __webpack_public_path__ + "static/img/6.18b9c0f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/amusement/6.png
// module id = Stq4
// module chunks = 1